import startCase from 'lodash/startCase';

export const useThemePrefix = (word, theme) => `${word}${startCase(theme)}`;
